import styled, { keyframes } from "styled-components";

const slideOut = keyframes`
0% {
    display: flex;
    transform: translateX(-60%);
    opacity: 0;
}
100% {
    transform: translateX(0);
    opacity: 1;
    display: flex;
}
`;

const StyledHomeSocials = styled.div`
  display: flex;
  padding-right: 40px;
  img {
    object-fit: contain;
    margin-right: 1.5rem;
  }
  & ul {
    display: flex;
    align-items: center;
    padding: 1rem 0;
    padding-left: 0.3rem;
    color: ${(props) => props.theme.fontColor};
  }
  & ul li {
    margin-right: 2.5rem;
  }

  & ul li a {
    display: flex;
    align-items: center;
    color: inherit;
  }

  & ul li a > svg {
    object-fit: contain;
    width: 22px;
    margin-right: 0.5rem;
    fill: ${(props) => props.theme.fontColor};
  }

  & ul li a p {
    display: flex;
    align-items: center;
    opacity: 0.6;
  }

  & ul li a p svg {
    object-fit: contain;
    width: 12px;
    margin-left: 5px;
    fill: ${(props) => props.theme.fontColor};
  }

  @media screen and (min-width: 750px) {
    & ul li {
      transition: all 1s ease-in-out;
    }
    & ul li a p {
      display: none;
      align-items: center;
      transform: translateX(-60%);
    }
    & ul li a:hover p {
      animation: 1s ${slideOut} ease-in-out;
      transform: translateX(0);
      opacity: 0.6;
      display: flex;
    }
  }

  @media screen and (max-width: 750px) {
    & ul li a p {
      font-size: 0.7rem;
      align-items: flex-end;
    }

    & ul li a > svg {
      width: 15px;
      margin-right: 0.3rem;
    }
    & ul li a p svg {
      width: 10px;
      margin-bottom: -2px;
    }
    & ul li {
      margin-right: 1.5rem;
    }
  }
`;

export const HomeSocials = () => {
  return (
    <StyledHomeSocials>
      <img className="mobile" src="images/blesstheboyimage.png" alt="" />
      <ul>
        <li>
          <a href="#" target="_blank" rel="noopener noreferrer">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M19.9975 0.416321C8.955 0.416321 0 9.40632 0 20.4963C0 29.3663 5.73 36.8913 13.68 39.5488C14.68 39.7338 15.045 39.1138 15.045 38.5813C15.045 38.1038 15.0275 36.8413 15.0175 35.1663C9.455 36.3788 8.28 32.4738 8.28 32.4738C7.3725 30.1538 6.06 29.5363 6.06 29.5363C4.2425 28.2913 6.195 28.3163 6.195 28.3163C8.2025 28.4588 9.2575 30.3863 9.2575 30.3863C11.0425 33.4538 13.94 32.5688 15.08 32.0538C15.26 30.7563 15.7775 29.8713 16.35 29.3688C11.91 28.8613 7.24 27.1388 7.24 19.4463C7.24 17.2538 8.02 15.4613 9.3 14.0563C9.0925 13.5488 8.4075 11.5063 9.495 8.74382C9.495 8.74382 11.175 8.20382 14.995 10.8013C16.59 10.3563 18.3 10.1338 20.0025 10.1263C21.7 10.1363 23.4125 10.3563 25.01 10.8038C28.8275 8.20632 30.505 8.74632 30.505 8.74632C31.595 11.5113 30.91 13.5513 30.705 14.0588C31.9875 15.4638 32.76 17.2563 32.76 19.4488C32.76 27.1613 28.085 28.8588 23.63 29.3563C24.3475 29.9763 24.9875 31.2013 24.9875 33.0738C24.9875 35.7588 24.9625 37.9238 24.9625 38.5813C24.9625 39.1188 25.3225 39.7438 26.3375 39.5463C34.275 36.8863 40 29.3638 40 20.4963C40 9.40632 31.045 0.416321 19.9975 0.416321Z" />
            </svg>
            <p>
              Github{" "}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M19.825 5.81596L14.4083 0.191032C14.2316 0.0077761 13.9608 -0.0497489 13.7251 0.0451597C13.4884 0.140984 13.3334 0.370168 13.3334 0.625139V3.33354H13.1251C8.64516 3.33354 5.00018 6.97852 5.00018 11.4584V12.7084C5.00018 12.9983 5.20434 13.24 5.48678 13.306C5.53271 13.3176 5.57848 13.3226 5.62426 13.3226C5.86016 13.3226 6.08599 13.1842 6.19509 12.9668C7.36679 10.6226 9.72257 9.16675 12.3434 9.16675H13.3334V11.875C13.3334 12.1301 13.4884 12.3593 13.7251 12.4542C13.9593 12.55 14.2316 12.4918 14.4083 12.3083L19.825 6.68342C20.0583 6.44096 20.0583 6.05934 19.825 5.81596Z" />
                <path d="M17.5 19.9999H2.5002C1.12189 19.9999 0.000228882 18.8784 0.000228882 17.4999V5.83347C0.000228882 4.45516 1.12189 3.3335 2.5002 3.3335H5.00016C5.46097 3.3335 5.83343 3.70596 5.83343 4.16677C5.83343 4.62758 5.46097 5.00004 5.00016 5.00004H2.5002C2.04015 5.00004 1.66677 5.37342 1.66677 5.83347V17.4999C1.66677 17.96 2.04015 18.3333 2.5002 18.3333H17.5C17.9599 18.3333 18.3333 17.96 18.3333 17.4999V10.8334C18.3333 10.3726 18.7057 9.99999 19.1665 9.99999C19.6275 9.99999 20 10.3726 20 10.8334V17.4999C20 18.8784 18.8783 19.9999 17.5 19.9999Z" />
              </svg>
            </p>
          </a>
        </li>
        <li>
          <a href="#" target="_blank" rel="noopener noreferrer">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0)">
                <path d="M40 7.5975C38.5125 8.25 36.9275 8.6825 35.275 8.8925C36.975 7.8775 38.2725 6.2825 38.8825 4.36C37.2975 5.305 35.5475 5.9725 33.6825 6.345C32.1775 4.7425 30.0325 3.75 27.6925 3.75C23.1525 3.75 19.4975 7.435 19.4975 11.9525C19.4975 12.6025 19.5525 13.2275 19.6875 13.8225C12.87 13.49 6.8375 10.2225 2.785 5.245C2.0775 6.4725 1.6625 7.8775 1.6625 9.39C1.6625 12.23 3.125 14.7475 5.305 16.205C3.9875 16.18 2.695 15.7975 1.6 15.195C1.6 15.22 1.6 15.2525 1.6 15.285C1.6 19.27 4.4425 22.58 8.17 23.3425C7.5025 23.525 6.775 23.6125 6.02 23.6125C5.495 23.6125 4.965 23.5825 4.4675 23.4725C5.53 26.72 8.545 29.1075 12.13 29.185C9.34 31.3675 5.7975 32.6825 1.9625 32.6825C1.29 32.6825 0.645 32.6525 0 32.57C3.6325 34.9125 7.9375 36.25 12.58 36.25C27.67 36.25 35.92 23.75 35.92 12.915C35.92 12.5525 35.9075 12.2025 35.89 11.855C37.5175 10.7 38.885 9.2575 40 7.5975Z" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="40" height="40" />
                </clipPath>
              </defs>
            </svg>
            <p>
              Twitter{" "}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M19.825 5.81596L14.4083 0.191032C14.2316 0.0077761 13.9608 -0.0497489 13.7251 0.0451597C13.4884 0.140984 13.3334 0.370168 13.3334 0.625139V3.33354H13.1251C8.64516 3.33354 5.00018 6.97852 5.00018 11.4584V12.7084C5.00018 12.9983 5.20434 13.24 5.48678 13.306C5.53271 13.3176 5.57848 13.3226 5.62426 13.3226C5.86016 13.3226 6.08599 13.1842 6.19509 12.9668C7.36679 10.6226 9.72257 9.16675 12.3434 9.16675H13.3334V11.875C13.3334 12.1301 13.4884 12.3593 13.7251 12.4542C13.9593 12.55 14.2316 12.4918 14.4083 12.3083L19.825 6.68342C20.0583 6.44096 20.0583 6.05934 19.825 5.81596Z" />
                <path d="M17.5 19.9999H2.5002C1.12189 19.9999 0.000228882 18.8784 0.000228882 17.4999V5.83347C0.000228882 4.45516 1.12189 3.3335 2.5002 3.3335H5.00016C5.46097 3.3335 5.83343 3.70596 5.83343 4.16677C5.83343 4.62758 5.46097 5.00004 5.00016 5.00004H2.5002C2.04015 5.00004 1.66677 5.37342 1.66677 5.83347V17.4999C1.66677 17.96 2.04015 18.3333 2.5002 18.3333H17.5C17.9599 18.3333 18.3333 17.96 18.3333 17.4999V10.8334C18.3333 10.3726 18.7057 9.99999 19.1665 9.99999C19.6275 9.99999 20 10.3726 20 10.8334V17.4999C20 18.8784 18.8783 19.9999 17.5 19.9999Z" />
              </svg>
            </p>
          </a>
        </li>
      </ul>
    </StyledHomeSocials>
  );
};
